<template>
	<div class="dropdown" :class="{ 'is-active': active }" v-click-outside-element="closeDropdown">
		<div class="dropdown-trigger" @click="toggleDropdown">
			<button class="button" :class="{ 'is-blue': selection.length }" aria-haspopup="true" aria-controls="dropdown-menu">
				<span v-text="label"></span>

				<span class="icon">
					<span></span>
				</span>
			</button>
		</div>

		<div class="dropdown-menu" id="dropdown-menu" role="menu">
			<div class="dropdown-content">
				<span
					v-for="option in options"
					:key="option.key"
					class="dropdown-item"
					:class="{ 'is-active': selection.includes(option.key) }"
				>
					<label class="checkbox">
						<input type="checkbox" :checked="selection.includes(option.key)" @change="select($event, option.key)" />
						<span v-html="getTermLabel(option)" :class="{ 'has-text-grey-lighter': isTermGreyedOut(option) }"></span>
					</label>
				</span>
			</div>
		</div>
	</div>
</template>

<script>

import { getFilteredStories } from '../../helpers/stories.js';
import filterMixin from '../../mixins/filter.js';

export default {
	mixins: [filterMixin],

	data() {
		return {
			/* Whether the dropdown box is visible or not */
			active: false,

			/* User-facing labels for each taxonomy */
			labels: {
				topics: 'Solution',
				industries: 'Industry',
			},
		};
	},

	computed: {
		/* User-facing dropdown label */
		label() {
			let label = this.labels[this.taxonomy] || 'Filter';

			if (this.selection.length > 0) {
				label += ` (${this.selection.length})`;
			}

			return label;
		},

		/* Number of stories each option would show if selected */
		optionStoryCounts() {
			const counts = {};

			for (const option of this.options) {
				const potentialTopics = this.taxonomy === 'topics' ? [option.key] : this.$store.filter.topics;
				const potentialIndustries = this.taxonomy === 'industries' ? [option.key] : this.$store.filter.industries;
				const potentialStories = getFilteredStories(this.$store.stories, potentialTopics, potentialIndustries);

				counts[option.key] = potentialStories.length;
			}

			return counts;
		},
	},

	methods: {
		/* Analytics event id for this component's selection events */
		analyticsEventName(key) {
			return `customer-story-filter-${this.taxonomy}-dropdown-${key}`;
		},

		/* Show or hide the dropdown box */
		toggleDropdown() {
			this.active = !this.active;
		},

		/* Hide the dropdown box */
		closeDropdown() {
			this.active = false;
		},

		/* Bridge the checkbox change event to the shared toggle handler */
		select(event, key) {
			const isChecked = event.target.checked;

			if (isChecked === this.selection.includes(key)) {
				return;
			}

			this.toggleSelection(key);
		},

		/* Display label for each option */
		getTermLabel(option) {
			return `${option.term} (${this.optionStoryCounts[option.key]})`;
		},

		isTermGreyedOut(option) {
			return this.optionStoryCounts[option.key] === 0;
		},
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.dropdown-content span {
	white-space: nowrap;
}

.dropdown-item {
	&.is-active {
		color: $blue;
		font-weight: $weight-semibold;
		background: rgba($blue, .05);
	}

	.checkbox {
		display: flex;
		gap: .5rem;
		padding: .125rem 0;
	}
}

.dropdown-trigger {
	span {
		font-variant-numeric: tabular-nums;
	}

	.icon {
		transition: transform .2s ease-in-out;
		transform: rotate(90deg);

		.is-active & {
			transform: rotate(-90deg);
		}

		span {
			display: inline-block;
			width: .75em;
			height: .75em;
			mask: url('/images/icons/ui/chevron.svg') no-repeat;
			mask-size: 100%;
			background-color: currentcolor;
		}
	}
}

</style>
